import { clientFetch } from "../../utils/service";
import { FETCH_PROFILE, LOGOUT_PROFILE } from './authActionsTypes';

export const fetchProfile = () => {
  return {
    type: FETCH_PROFILE,
    payload: clientFetch('/users/me'),
  };
};

export const logoutUser = () => {
  return {
    type: LOGOUT_PROFILE,
  };
};
